
export enum TipoRecorrenciaAlbumFotos {
  Semanal = 'Semanal',
  Quinzenal = 'Quinzenal',
  Mensal = 'Mensal',
}
